export default `
{{nbHits}} results
    {{#query}}
        for <span class="tw-text-green-500">&ldquo;{{query}}&rdquo;</span>
    {{/query}}
`;

